<template src="./Livemap.html"></template>
<script lang="js">
import Vue from 'vue';

export default Vue.extend({
  name: 'nmouc-livemap',
  computed: {
    showManualUpdateBtn() {
      return this.$store.state.mapupdateInformation && this.$store.state.mapupdateInformation.mapRegions.some(val => val.upToDate === false);
    },
    textModelDescription() {
      if (this.$store.state.model === undefined) {
        return '';
      }
      return '<span class=\'model-description-no-wrap\'>' + this.$store.state.model + '</span>';
    }
  },
});
</script>
<style lang="scss" src="./Livemap.scss"></style>
